module.exports = __webpack_public_path__ + "static/media/rayan.27ff5671.jpg";